import { Calendar } from "antd";
import { Modal, OverlayTrigger, Popover } from "react-bootstrap";

import dayjs from "dayjs";
import "dayjs/locale/fr";
import "antd/dist/reset.css";
import { getWeeksMondaySunday } from "../../helper/getWeeksMondaySunday";
import { useEffect, useState } from "react";
import { useAcademicYear } from "../../core/common/context/AcademicYearContext";
import { parseAcademicYearString } from "../../helper/parseAcademicYearString";
import { toast } from "sonner";
import { updateEDT } from "../../api/edt";
import withPermission from "../../core/common/autorisations/withPermission";
import {
  Action,
  buildPermission,
  Resource,
} from "../../core/common/autorisations/permissionsMap";

type Props = {
  show: boolean;
  dataEDT: any;
  onSave: () => void;
  onClose: () => void;
};

const EdtEditModal = ({ show, onSave, onClose, dataEDT }: Props) => {
  const { selectedYear } = useAcademicYear();
  const [weeksOfYear, setWeeksOfYear] = useState<number[]>([]);
  const [selectedWeek, setSelectedWeek] = useState<number>();
  const [yearsOfSholarship, setYearsOfSholarship] = useState<number[]>([]);
  const [selectedYearScholarship, setselectedYearScholarship] =
    useState<number>();
  const [newEDTName, setNewEDTName] = useState<string>("");
  const [error, setError] = useState<string>("");

  useEffect(() => {
    if (!selectedYear) return;
    const years = parseAcademicYearString(selectedYear?.label);
    setYearsOfSholarship(years.map((y) => parseInt(y)));
    // setSelectedWeek(1);
  }, [selectedYear]);

  useEffect(() => {
    if (!yearsOfSholarship.length) return;
    setselectedYearScholarship(yearsOfSholarship[0]);
  }, [yearsOfSholarship]);

  useEffect(() => {
    if (!selectedYearScholarship) return;
    const weeks = getWeeksMondaySunday(selectedYearScholarship);
    setWeeksOfYear(weeks.map((_, i) => i + 1));

    // startDate est sous la forme dd/mm/yyyy->yyyy-mm-dd pour le constructor de Date
    const [day, month, year] = dataEDT?.startDate.split("/");
    const startDate = new Date(`${year}-${month}-${day}`);

    const matchedWeek = weeks.findIndex((week) =>
      week.some(
        (day) =>
          day.getDate() === startDate.getDate() &&
          day.getMonth() === startDate.getMonth() &&
          day.getFullYear() === startDate.getFullYear(),
      ),
    );
    if (matchedWeek !== -1) setSelectedWeek(matchedWeek + 1);
    else setSelectedWeek(undefined);
  }, [selectedYearScholarship]);

  useEffect(() => {
    if (!dataEDT || !show) return;
    // console.log("dataEDT: ", dataEDT);
    setNewEDTName(dataEDT?.nom);

    // startDate est sous la forme dd/mm/yyyy->yyyy-mm-dd pour le constructor de Date
    const [day, month, year] = dataEDT?.startDate.split("/");
    const startDate = new Date(`${year}-${month}-${day}`);

    const matchedYear = yearsOfSholarship.find(
      (year) => year == startDate.getFullYear(),
    );
    if (matchedYear) {
      //   console.log("matchedYear: ", matchedYear);
      setselectedYearScholarship(matchedYear);
    }
  }, [dataEDT, show]);

  //   fonction pour gérer la soumission du formulaire
  const handleSubmit = async () => {
    setError("");
    try {
      if (!newEDTName) {
        setError("Entréun nom pour l'emplois du temps");
        return;
      }
      if (!selectedWeek) {
        setError("Sélectionné une semaine valide pour l' emplois du temps");
        return;
      }
      const weeks = getWeeksMondaySunday(
        selectedYearScholarship || new Date().getFullYear(),
      );

      const payload = {
        id_academicYear: selectedYear?.id,
        title: newEDTName,
        valid_from: weeks[selectedWeek - 1][0],
        valid_until: weeks[selectedWeek - 1][6],
      };

      const res = await updateEDT(dataEDT?.id, payload);
      //   console.log("response: ", res.data);
      onSave();
      onClose();
      toast.success("EDT modifié avec succès");
    } catch (error: any) {
      console.log("erreur lors de la modification de l'EDT : ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title className="d-flex align-items-center gap-4">
          <i className="ion ion-calendar fs-2"></i>
          <h5 className="modal-title">Modifier Emplois du temps</h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form className="d-flex flex-column gap-3">
          <div>
            {/* Select pour les années de l'année scolaire */}
            <div className="form-group">
              <label>Année scolaire</label>
              <select
                className="form-select"
                value={selectedYearScholarship}
                onChange={(e) =>
                  setselectedYearScholarship(parseInt(e.target.value))
                }
              >
                {yearsOfSholarship.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>
                Période de validité (semaines de l'année académique)
              </label>
              <div className="d-flex flex-wrap gap-2 mt-2">
                {weeksOfYear.map((w, index) => {
                  const allWeeks = getWeeksMondaySunday(
                    selectedYearScholarship || new Date().getFullYear(),
                  );
                  const weekDays = allWeeks[index] || []; // les 7 jours de la semaine

                  return (
                    <OverlayTrigger
                      key={w}
                      placement="top"
                      overlay={
                        <Popover id={`popover-week-${w}`}>
                          <Popover.Body>
                            <div>
                              <Calendar
                                fullscreen={false}
                                // locale={frFR}
                                mode="month"
                                defaultValue={dayjs(weekDays[0])}
                                disabledDate={() => true}
                                headerRender={({
                                  value,
                                  type,
                                  onChange,
                                  onTypeChange,
                                }) => {
                                  return (
                                    <div
                                      style={{
                                        padding: "8px 0",
                                        textAlign: "center",
                                      }}
                                    >
                                      <span>
                                        Semaine {w} -{" "}
                                        {value.format("MMMM YYYY")}
                                      </span>
                                    </div>
                                  );
                                }}
                                fullCellRender={(date) => {
                                  const isInWeek = weekDays.some(
                                    (day) =>
                                      day.getDate() === date.date() &&
                                      day.getMonth() === date.month() &&
                                      day.getFullYear() === date.year(),
                                  );
                                  const isFirstDay =
                                    date.date() === weekDays[0].getDate() &&
                                    date.month() === weekDays[0].getMonth() &&
                                    date.year() === weekDays[0].getFullYear();
                                  const isLastDay =
                                    date.date() === weekDays[6].getDate() &&
                                    date.month() === weekDays[6].getMonth() &&
                                    date.year() === weekDays[6].getFullYear();
                                  return (
                                    <div
                                      style={{
                                        height: "24px",
                                        width: "100%",
                                        textAlign: "center",
                                        lineHeight: "24px",
                                        backgroundColor:
                                          isFirstDay || isLastDay
                                            ? "#0d6efd"
                                            : isInWeek
                                              ? "#6ab0f0"
                                              : "transparent",
                                        color: isInWeek ? "white" : "inherit",
                                        borderRadius:
                                          isFirstDay || isLastDay ? "5px" : "",
                                      }}
                                    >
                                      {date.date()}
                                    </div>
                                  );
                                }}
                              />
                            </div>
                          </Popover.Body>
                        </Popover>
                      }
                    >
                      <div
                        className="form-check form-check-inline p-0 m-0"
                        style={{ width: 40, height: 40 }}
                      >
                        <input
                          className="d-none"
                          type="checkbox"
                          id={`week-${w}`}
                          value={w}
                          checked={selectedWeek === w}
                          // disabled={
                          //   !weekDays.some(
                          //     (d) =>
                          //       d.toDateString() === new Date().toDateString()
                          //   ) && weekDays[6] < new Date()
                          // }
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedWeek(w);
                            }
                          }}
                        />
                        <label
                          className="week-check-label d-flex align-items-center justify-content-center"
                          htmlFor={`week-${w}`}
                          style={{
                            width: 36,
                            height: 36,
                            borderRadius: "50%",
                            border: "2px solid #0d6efd",
                            cursor: "pointer",
                            fontWeight: 500,
                            fontSize: 16,
                            transition: "background 0.2s, color 0.2s",
                            userSelect: "none",
                            opacity:
                              !weekDays.some(
                                (d) =>
                                  d.toDateString() ===
                                  new Date().toDateString(),
                              ) && weekDays[6] < new Date()
                                ? 0.5
                                : 1,
                          }}
                        >
                          {w}
                        </label>
                        {/* <label
                        className="week-check-label d-flex align-items-center justify-content-center"
                        htmlFor={`week-${w}`}
                        style={{
                          width: 36,
                          height: 36,
                          borderRadius: "50%",
                          border: "2px solid #0d6efd",
                          cursor: "pointer",
                          fontWeight: 500,
                          fontSize: 16,
                          transition: "background 0.2s, color 0.2s",
                          userSelect: "none",
                        }}
                      >
                        {w}
                      </label> */}
                      </div>
                    </OverlayTrigger>
                  );
                })}
              </div>
            </div>

            {/* Input pour le nom du nouvel emploi du temps */}
            <div className="form-group">
              <label>Nom de l'emploi du temps</label>
              <input
                type="text"
                className="form-control"
                placeholder="Ex: EDT 2024-2025"
                value={newEDTName}
                onChange={(e) => setNewEDTName(e.target.value)}
              />
            </div>

            <style>
              {`
                  .week-check-label {
                    background: #fff;
                    color: #0d6efd;
                  }
                  input[type="checkbox"]:checked + .week-check-label {
                    background: #0d6efd;
                    color: #fff;
                    border-color: #0d6efd;
                  }
                `}
            </style>
          </div>
          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}
          <div className="d-flex justify-content-end gap-2 mt-3">
            <button
              onClick={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
              className="btn btn-primary"
            >
              Enregistrer
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default withPermission(
  EdtEditModal,
  [buildPermission(Resource.EDT, Action.UPDATE)],
  "masquer",
);
